import { render, staticRenderFns } from "./MealPricesBasedByOrganisationalLocationView.vue?vue&type=template&id=4de78f92&"
import script from "./MealPricesBasedByOrganisationalLocationView.vue?vue&type=script&lang=js&"
export * from "./MealPricesBasedByOrganisationalLocationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports